export default __webpack_public_path__ + "static/chance-to-challenge-balthazaurus-scroll-4a22215446cdc51c6d00a359230648a0.mp4";